<script>
    import ProjectGallery from "./project-gallery/ProjectGallery.svelte";
    import ProjectInfo from "./project-info/ProjectInfo.svelte";
    import {projectDetail} from "../../../store";
    import {PROJECT_STATUSES} from "../../../constants/constants";
    let backIcon = "./images/back-arrow.svg";

    export let saleCardDetails, sale, token, reserve, saleData, projectTierData;
</script>
<header class="gallery-header flex items-center">
    <div class="flex-1">
        <a href="/" class="flex items-center"><img src={backIcon} alt="back icon">Go Back Projects</a>
        <h2>{$projectDetail.project_name}</h2>
        <p>{$projectDetail.project_description}</p>
    </div>
    <div class="ml-auto flex items-center">
        <div class={`tier-badge-btn ${$projectDetail.project_status && $projectDetail.project_status.toLowerCase()}`}>{$projectDetail.project_status === PROJECT_STATUSES.LIVE ? "Ongoing" : $projectDetail.project_status}</div>
    </div>
</header>
<div class="visual flex">

    {#if $projectDetail.project_cover}
        <ProjectGallery img={$projectDetail.project_cover} {projectTierData} />
    {/if}
    <ProjectInfo {projectTierData} {saleData} {sale} {reserve} {token} {saleCardDetails} />
</div>
